import { ButtonDock, miniButtonDockScrollBottomPad } from '@focuslee/shared-mini-app';
import { Stack } from '@mui/material';
import { type FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Page } from '../components/Page';
import { VoiceCommandsDocsDetailPanel } from '../components/voice/docs/VoiceCommandsDocsDetailPanel';
import { VoiceCommandsDocsTabBar } from '../components/voice/docs/VoiceCommandsDocsTabBar';
import { VOICE_COMMAND_DOCS, sortVoiceParams } from '../data/voiceCommandsDocs';

export const VoiceCommandsDocsPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cmdParam = searchParams.get('cmd');
  const navigateBack = useCallback(() => navigate(-1), [navigate]);

  const initialId = useMemo(() => {
    if (cmdParam && VOICE_COMMAND_DOCS.some((c) => c.id === cmdParam)) return cmdParam;
    return VOICE_COMMAND_DOCS[0].id;
  }, [cmdParam]);

  const [activeId, setActiveId] = useState(initialId);

  useEffect(() => {
    setActiveId(initialId);
  }, [initialId]);

  const active = VOICE_COMMAND_DOCS.find((c) => c.id === activeId) ?? VOICE_COMMAND_DOCS[0];
  const sortedParams = sortVoiceParams(active.params);

  return (
    <Page
      footer={
        <Stack>
          <VoiceCommandsDocsTabBar activeId={activeId} onSelect={setActiveId} />
          <ButtonDock main={{ text: t('actions.back'), onClick: navigateBack, navigation: 'back' }} />
        </Stack>
      }
    >
      <Stack sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 2, pt: 1.5, pb: `calc(${miniButtonDockScrollBottomPad} + 60px)` }}>
        <VoiceCommandsDocsDetailPanel cmd={active} sortedParams={sortedParams} />
      </Stack>
    </Page>
  );
};
